module.exports = __webpack_public_path__ + "static/media/DoubleRing-1s-200px(1).c99d3cca.svg";